import { useTranslation } from "react-i18next"
import { T } from "../i18n/LocaleType";
import style from './Loading.module.css';
import { motion } from "motion/react";

/** Stránka pro načítání obsahu */
export const Loading: React.FC = () => {

    const { t } = useTranslation();

    return <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className={style.loading}
        style={{ position: 'absolute', inset: 0 }}
    >
        <div className={style.container}>
            <div className={style.spinner}></div>
            {t(T.loading)}
        </div>
    </motion.div>
}